export default __webpack_public_path__ + "static/media/arrow.0e5c514c.svg";